import { CurrentUserDTO } from '@app/auth/dto';
import { createContext, PropsWithChildren, useContext } from 'react';

type CurrentUserContextType = {
  user?: CurrentUserDTO;
  updateUserData: () => Promise<void>;
};

export const CurrentUserContext = createContext<CurrentUserContextType>({
  updateUserData: () => new Promise(() => {}),
});

export const CurrentUserContextProvider = ({
  children,
  user,
  updateUserData,
}: PropsWithChildren<{ user?: CurrentUserDTO; updateUserData: () => Promise<void> }>) => (
  <CurrentUserContext.Provider
    value={{
      user,
      updateUserData,
    }}
  >
    {children}
  </CurrentUserContext.Provider>
);

export const useCurrentUserContext = () => useContext(CurrentUserContext);
